import { ArrowLeft, ArrowLeft2, ArrowRight2, Category, InfoCircle, Save2 } from "iconsax-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import work_times from "../../../utils/work_time";
import { Check } from "lucide-react";
import { Friday, Monday, Saturday, Sunday, Thursday, Tuesday, Wednesday } from "../days/days";
import storageNames from "../../../utils/storage_names";
import instance from "../../../../../../axios/instance"
import { toast } from "react-toastify";

export default function AvailabilityPage() {

    const navigate = useNavigate()
    const [currentDay, setCurrentDay] = useState(0)

    function handleMondayData(data) {
        console.log("Monday data is", data);
    }

    function getFullAvailabilityData() {
        return ({
            monday: JSON.parse(window.localStorage.getItem(storageNames.MONDAY_DATA)),
            tuesday: JSON.parse(window.localStorage.getItem(storageNames.TUESDAY_DATA)),
            wednesday: JSON.parse(window.localStorage.getItem(storageNames.WEDNESDAY_DATA)),
            thursday: JSON.parse(window.localStorage.getItem(storageNames.THURSDAY_DATA)),
            friday: JSON.parse(window.localStorage.getItem(storageNames.FRIDAY_DATA)),
            saturday: JSON.parse(window.localStorage.getItem(storageNames.SATURDAY_DATA)),
            sunday: JSON.parse(window.localStorage.getItem(storageNames.SUNDAY_DATA))
        })
    }

    const days = [
        { 
            day_id: 1, 
            day: "Monday",
            component: <Monday currentDay={currentDay} />
        },
        { 
            day_id: 2, 
            day: "Tuesday",
            component: <Tuesday currentDay={currentDay} />
        },
        { 
            day_id: 3, 
            day: "Wednesday" ,
            component: <Wednesday currentDay={currentDay} />
        },
        { 
            day_id: 4, 
            day: "Thursday" ,
            component: <Thursday currentDay={currentDay} />
        },
        { 
            day_id: 5, 
            day: "Friday",
            component: <Friday currentDay={currentDay} />
        },
        { 
            day_id: 6, 
            day: "Saturday",
            component: <Saturday currentDay={currentDay} />
        },
        { 
            day_id: 7, 
            day: "Sunday",
            component: <Sunday currentDay={currentDay} />
        }
    ]

    function goBack() {
        if (currentDay === 0) {
            return 
        }

        setCurrentDay(currentDay - 1)
    }

    function goNext() {
        if (currentDay === (days.length - 1)) {
            return 
        }
        setCurrentDay(currentDay + 1)
    }

    function handleAvailabilitySave() {
        console.log("availability");
        console.log(getFullAvailabilityData());

        const token = window.sessionStorage.getItem("ACCESS_TOKEN")

        instance.post("/telemedicine/doctor/availability", {
            availability: getFullAvailabilityData()
        }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        .then(response => {
            console.log(response.data);
            toast.success(response.data.message, {
                position: "bottom-right"
            })
        })
        .catch(error => {
            console.log(error.response.data);
            toast.error(error.response.data.message, {
                position: "bottom-right"
            })
            
        })
    }

    return (
        <div className="p-3 overflow-y-scroll space-y-10">
            <div className="flex items-center gap-2">
                <button onClick={() => navigate(-1)}>
                    <ArrowLeft size={20} />    
                </button>
                
                <div className="font-medium text-[17px]">Edit Availability</div>
            </div>

            <div className="space-y-6">
                <div className="flex justify-between">
                    <button onClick={goBack} className="w-10 bg-[#00b0ad22] h-10 flex justify-center items-center border rounded-[4px] border-[#00b0ad]">
                        <ArrowLeft2 size={20} color="#00b0ad" variant="Bold" />
                    </button>

                    <div className="px-10 py-2 bg-[#00b0ad] text-white font-medium text-[15px] rounded-[4px]">{days[currentDay].day}</div>

                    <button onClick={goNext} className="w-10 bg-[#00b0ad22] h-10 flex justify-center items-center border rounded-[4px] border-[#00b0ad]">
                        <ArrowRight2 size={20} color="#00b0ad" variant="Bold" />
                    </button>
                </div>

                {days[currentDay].component}
            </div>
           
            <div className="absolute bottom-3 right-3 flex flex-col gap-2">
                <button onClick={handleAvailabilitySave} className="shadow-sm self-end flex gap-2 px-6 py-[6px] text-[14px] border border-[#00b0ad] bg-[#00b0ad] text-white items-center rounded-[4px] font-medium">
                    <Check size={16} color="#fff" />
                    Save availability
                </button>

                <div className="flex gap-1 text-[#dd4b39] items-center font-regular text-[14px]">
                    <InfoCircle size={14} />
                    <div>Make sure to save changes before exiting</div>
                </div>
            </div>
        </div>
    )
}

